import { contentService } from '../../../services/content/content-service'

/**
 * Generate manual content method for the useContentGeneration composable
 * @param {Object} state - Content state object
 * @returns {Function} Generate manual content function
 */
export const createGenerateManualContent = (state) => {
  /**
   * Generate content from manual form input
   * @param {Object} formData - Manual content form data
   * @param {Object} assetStore - Asset store instance
   * @param {Object} dependencies - Additional dependencies
   * @returns {Promise<boolean>} Success status
   */
  return async (formData, assetStore, dependencies = {}) => {
    return await contentService.generateManualContent(formData, assetStore, {
      state,
      ...dependencies,
    })
  }
}
